import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth-context";
import { supabase } from "@/integrations/supabase/client";

export const useAdminCheck = () => {
  const { user, loading: authLoading } = useAuth();

  // Cache admin status across navigations to avoid spinner flashes / re-fetches
  // every time RequireAdmin or AdminLayout remounts on route change.
  const { data: isAdmin = false, isLoading: roleLoading } = useQuery({
    queryKey: ["admin-check", user?.id],
    enabled: !!user && !authLoading,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (!user) return false;
      const { data, error } = await supabase.rpc("has_role", {
        _user_id: user.id,
        _role: "admin",
      });
      if (error) return false;
      return data === true;
    },
  });

  const loading = authLoading || (!!user && roleLoading);
  return { isAdmin, loading, user };
};
